export const COLOR_PERFORMANCE: string = "dark";
